module.exports = __webpack_public_path__ + "media/images/banner/tcvb/tcvb-ko-d764d5b204c78cd307ee3b5fe5db545d.jpg";